import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IWorkflowCollectionState } from '../../../../workflow/store/workflow.reducer';
import { ActivatedRoute, Router } from '@angular/router';
import { Guid } from 'guid-typescript';
import { Configuration } from '@shared/models/configuration';
import { CleanWorkflowDataAction, CreateWorkflowAction } from '../../../../workflow/store/workflow.actions';
import { getWorkflowReducerState, isWorkflowCleanedUp } from '../../../../workflow/store/workflow.selector';

@Component({
    standalone: false,
    selector: 'particle-participants-entity-manager-export',
  templateUrl: './participants-entity-manager-export.component.html',
  styleUrls: ['./participants-entity-manager-export.component.scss']
})
export class ParticipantsEntityManagerExportComponent implements OnInit {

  workflowTemplate = '';
  workflowState$: any;
  workflowId: string;
  cleanedUp$: any;
  apiEndpointKey: string;
  genericParticipantsExportKey: string;
  genericFieldsKey: string;
  selectParticipantsTitle: string;
  caseId: string;
  sourceType: string;
  participantsFilterTemplateId: string;
  constructor(private store: Store<IWorkflowCollectionState>,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.workflowId =  Guid.create().toString();
    this.apiEndpointKey = 'Dac6Api';
    this.init();
  }
  init(){
    this.workflowTemplate = 'generic-export-participants-ui-workflow';
    this.genericParticipantsExportKey = 'GENERIC-EXPORT-PARTICIPANTS';
    this.genericFieldsKey = 'Dac6Generic-Fields';
    if(this.router.url.toLowerCase().includes('relevant-taxpayers')){
      this.sourceType = 'Relevant-Taxpayers';
      this.selectParticipantsTitle = 'Select Relevant Taxpayers';
    }
    else if(this.router.url.toLowerCase().includes('intermediaries')){
      this.sourceType = 'Intermediaries';
      this.selectParticipantsTitle = 'Select Intermediaries';
    }
    else if(this.router.url.toLowerCase().includes('other-persons')){
      this.sourceType = 'Other-Persons';
      this.selectParticipantsTitle = 'Select Other Persons';
    }
    this.participantsFilterTemplateId = 'dac6-' + this.sourceType.toLowerCase()+ '-selector-filter';
  }
  ngOnInit() {
    const selected = Configuration.getSmartGridConfig(this.genericParticipantsExportKey + '-SELECTED');
    const notSelected = Configuration.getSmartGridConfig(this.genericParticipantsExportKey + '-NOT-SELECTED');
    const fields = Configuration.getSmartGridConfig(this.genericFieldsKey);
    this.activatedRoute.params.subscribe(params => {
      if (params['caseId']) {
        this.caseId = params['caseId'];
        selected.Parameters['CASE_ID'] = this.caseId;
        notSelected.Parameters['CASE_ID'] = this.caseId;
      } else {
        this.caseId = '';
        selected.Parameters['CASE_ID'] = '';
        notSelected.Parameters['CASE_ID'] = '';
      }
      selected.Parameters['SOURCE_TYPE'] = this.sourceType;
      selected.FilterConfig['ItemType'] = this.sourceType;
      notSelected.Parameters['SOURCE_TYPE'] = this.sourceType;
      notSelected.FilterConfig['ItemType'] = this.sourceType;
      // TODO: need attention, it's SourceType inside core business :(
      fields.Parameters['SourceType'] = this.sourceType;
    });

    const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(url, this.workflowId , 'Export', this.workflowTemplate);

    action.setParameters({
      'SourceType' : this.sourceType,
      'SelectParticipantsTitle' : this.selectParticipantsTitle,
      'ParticipantsFilterTemplateId': this.participantsFilterTemplateId
    });

    this.store.dispatch(action);
    this.workflowState$ = this.store.pipe(select(getWorkflowReducerState, this.workflowId ));
    this.workflowState$.subscribe(state => {
      if (state) {
        this.cleanWorkflow();
      }

    });
  }

  cleanWorkflow() {
    this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.subscribe(state => {
      if (state === 'Finished' || state === 'Cancelled') {
        this.store.dispatch(new CleanWorkflowDataAction(this.workflowId));
        this.router.navigate(['..'],  {relativeTo: this.activatedRoute});
      }
    });
  }

  onGridCellValueChange($event) {
    console.log('cell value change', $event);
  }
}
